import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useGetList = (
  schoolId,
  trainingId,
  accessToken,
  page = 1,
  pageSize = 30,
  filter
) => {
  return useQuery(
    [
      "classes",
      schoolId,
      trainingId,
      accessToken,
      page,
      pageSize,
      JSON.stringify(filter),
    ],
    async () => {
      let levelId = filter?.level_id;
      let slotId = filter?.slot_id;
      let teacherMemberId = filter?.teacher_member_id;
      if (levelId === undefined) {
        levelId = "";
      }
      if (slotId === undefined) {
        slotId = "";
      }
      if (teacherMemberId === undefined) {
        teacherMemberId = "";
      }
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/classes?page=${page}&pageSize=${pageSize}&level_id=${levelId}&slot_id=${slotId}&teacher_member_id=${teacherMemberId}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch classes!");
        }
        if (response.status >= 299) {
          throw new Error("Erreur de récupération de la liste des classes!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        // Handle the error
        console.error("Error fetching classes:", error);
        throw error;
      }
    }
  );
};

const GetOne = (schoolId, trainingId, accessToken, classId) => {
  return useQuery(
    ["slot", schoolId, trainingId, accessToken, classId],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/classes/${classId}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Erreur de récupération de la classe!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        throw error;
      }
    }
  );
};

const CreateOne = async (schoolId, trainingId, accessToken, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/classes",
      {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de création de la classe!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const UpdateOne = async (schoolId, trainingId, accessToken, classId, data) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/classes/" +
      classId,
      {
        method: "PATCH",
        body: JSON.stringify(data),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de modification de la classe!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const DeleteOne = async (schoolId, trainingId, accessToken, classId) => {
  try {
    const response = await fetch(
      BACKEND_URL +
      "/api/v1/schools/" +
      schoolId +
      "/trainings/" +
      trainingId +
      "/classes/" +
      classId,
      {
        method: "DELETE",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    );
    if (!response.ok) {
      throw new Error(`Erreur de suppression de la classe!`);
    }
    let actualData = await response.json();
    return actualData;
  } catch (err) {
    throw err;
  }
};

const classesAPI = {
  useGetList,
  GetOne,
  CreateOne,
  UpdateOne,
  DeleteOne,
};

export default classesAPI;
